import React, { useMemo } from 'react';
import { Article } from '@phosphor-icons/react';
import classNames from 'classnames';
import { Link, useParams, useNavigate } from 'react-router-dom';

import {
  PageWrapper,
  ContentHeader,
  BackBtn,
} from '../../components/layout/content';

import { useWindowWidth } from '../../hooks/useWindowWidth';
import { getHelpUrl, scrollToTop, getBpWidth } from '../../utils';

import ArticleContent from './components/articleContent';
import HelpForm from './components/helpForm';
import { helpContent } from './content';

const HelpArticle = () => {
  const { topicSlug = '', articleSlug = '' } = useParams();

  const navigate = useNavigate();

  const windowWidth = useWindowWidth();
  const isMobileDevice = useMemo(
    () => windowWidth < getBpWidth('lg'),
    [windowWidth],
  );

  const { content, allArticles } = useMemo(() => {
    const allArticles = helpContent.find(
      (topic) => topic.slug === topicSlug,
    )?.articles;

    const content = allArticles?.find(
      (article) => article.slug === articleSlug,
    )?.content;

    return { content, allArticles };
  }, [topicSlug, articleSlug]);

  return (
    <PageWrapper type="generic" title="Help" className="gap-6">
      <div>
        {isMobileDevice && (
          <BackBtn
            onClick={() => navigate(getHelpUrl(topicSlug))}
            label="Back"
          />
        )}

        <ContentHeader title={content?.title} subtitle={content?.subtitle} />
      </div>

      <div className="flex flex-col sm:flex-row gap-8 sm:gap-16">
        <div className="w-full sm:w-3/4 flex flex-col gap-8 sm:gap-12">
          {content && <ArticleContent content={content} />}

          <HelpForm />
        </div>

        <hr className="sm:hidden" />

        <div className="w-full sm:w-1/4">
          <div className="sm:sticky sm:top-0 w-full flex flex-col gap-4">
            <h5>Help</h5>

            <div className="flex flex-col gap-2">
              {allArticles?.map((article) => (
                <Link
                  key={article.slug}
                  to={`/help/${topicSlug}/${article.slug}`}
                  onClick={scrollToTop}
                  className={classNames({
                    'flex items-center gap-2 text-black no-underline hover:opacity-100': true,
                    'font-semibold cursor-default':
                      article.slug === articleSlug,
                    'hover:text-primary-900': article.slug !== articleSlug,
                  })}
                >
                  <Article size="1.25rem" />
                  <div>{article.content.title}</div>
                </Link>
              ))}
            </div>

            <Link
              to={getHelpUrl()}
              onClick={scrollToTop}
              className="text-black hover:opacity-100 hover:text-primary-900"
            >
              Browse all help topics
            </Link>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default HelpArticle;
